import { makeStyles } from "@material-ui/core";
import { DraggableBox } from "../../atoms/DraggableBox/DraggableBox";
import CloseIcon from '@material-ui/icons/Close';
import CustomizedMaterialTreeView from "../../atoms/materialTree/materialTree";
import { useEffect, useState, useRef } from "react";
import useDebounce from "../../../hooks/useDebounce";

const useStyles = makeStyles({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1rem',
        paddingBottom: '0.5rem',
        minWidth: '8rem'
    },
    heading: {
        fontSize: "12px",
        margin: 0
    },
    smallIcon: {
        fontSize: "16px",
        cursor: "pointer"
    },
})

function MessageSchemaModal({x, y, message, setQuickViewMessages}){
    const classes = useStyles();

    const initialPositionRef = useRef({ x, y });

    const [position, setPosition] = useState(initialPositionRef.current);


    const [dragPostion, setDragPosition] = useState(null)
    const debouncePosition = useDebounce(dragPostion, 50)

    const onClose = () =>{
        setQuickViewMessages(prev => {
            const filtered = prev.filter(item => item.message.eventId !== message.eventId);
            return filtered
        })
    }

    // useEffect(() => {
    //     if(debouncePosition){
    //         setQuickViewMessages(prev => {
    //             return prev.map(item => {
    //                 if(item.message.eventId === message.eventId){
    //                     item.x = debouncePosition.x
    //                     item.y = debouncePosition.y
    //                 }
    //                 return item
    //             })
    //         })
    //     }
    // },[debouncePosition])

    const handleDrag = (pos) => {
        setPosition(pos);      
        setDragPosition(pos);   
    };

    useEffect(() => {
        if (!debouncePosition) return;

        setQuickViewMessages((prev) =>
            prev.map((item) =>
                item.message.eventId === message.eventId
                    ? {
                        ...item,
                        x: debouncePosition.x,
                        y: debouncePosition.y,
                    }
                    : item
            )
        );
    }, [debouncePosition, message.eventId, setQuickViewMessages]);

    return(
        <DraggableBox id={`draggable_${message.evenName || message.eventName}_modal`} className={"messsage-quickview-modal"} initialPosition={initialPositionRef.current} setDragPosition={setDragPosition}       onDrag={handleDrag}>
            <div className={`${classes.header} messsage-quickview-modal-header`}>
                <h6 className={classes.heading}>{message.evenName || message.eventName}</h6>
                <CloseIcon id={"close_modal"} onClick={onClose} className={classes.smallIcon}/>
            </div>
            <CustomizedMaterialTreeView message={message} />
        </DraggableBox>
    )
}

export default MessageSchemaModal;